import { useTranslation } from 'react-i18next';

import { IconButton } from '../Ant';
import { LinearCross } from '../icons';

interface LookupClearButtonProps {
  'data-testid'?: string;
  disabled?: boolean;
  onClick: () => void;
}

/** A searchable select puts its own search button between the trigger and this one. */
const findTrigger = (clearButton: HTMLElement) => {
  const previous = clearButton.previousElementSibling;
  return previous?.classList.contains('lookup-search-btn')
    ? previous.previousElementSibling
    : previous;
};

/**
 * Clears the value of an `add-transaction-btn` lookup field. It renders as the trigger button's
 * next sibling and overlaps its right edge, because a `<button>` inside a `<button>` is invalid
 * HTML and makes React bail out of hydration. Clearing unmounts it, so focus moves to the trigger.
 */
const LookupClearButton: React.FC<LookupClearButtonProps> = ({ disabled, onClick, ...rest }) => {
  const { t } = useTranslation();

  const clearAndFocusTrigger = (event: React.MouseEvent<HTMLElement>) => {
    const trigger = findTrigger(event.currentTarget);
    onClick();
    if (trigger instanceof HTMLElement) trigger.focus();
  };

  return (
    <IconButton
      {...rest}
      aria-label={t('common:clear')}
      className="clear-icon-btn lookup-clear-btn"
      disabled={disabled}
      icon={<LinearCross />}
      onClick={clearAndFocusTrigger}
    />
  );
};

export default LookupClearButton;
